import { render } from "./FormCheckInput.vue?vue&type=template&id=52428a64&ts=true"
import script from "./FormCheckInput.vue?vue&type=script&lang=ts"
export * from "./FormCheckInput.vue?vue&type=script&lang=ts"

import "./FormCheckInput.vue?vue&type=style&index=0&id=52428a64&lang=css"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__